import React, {useState} from 'react'
import FoodListItem from './food-list-item'
import Item from './item'
import Modal from '../../../../../../components/modal'
import {RecipeCard} from './recipe-card'

const FoodList = (props) => {
  const trackerData = props.trackerData
  const [showRecipeModal, setShowRecipeModal] = useState(false)
  const [item, setItem] = useState('')

  const getTotalMacros = (category) => {
    let items = trackerData.timeline[trackerData.selectedTrackerDate]
    let totalProtein = 0
    let totalCarbs = 0
    let totalFats = 0
    let totalCalories = 0

    if (items) {
      items.forEach((item) => {
        if(category === 'other') {
          if(item.itemType === 'recipe' && (item.category === category || !item.category)) {
            item = new Item(item)
            totalProtein += item.getRecipeProtein()
            totalCarbs += item.getRecipeCarbs()
            totalFats += item.getRecipeFat()
          }
          else if((item.category === category || !item.category)) {
            item = new Item(item)
            totalProtein += item.getProtein()
            totalCarbs += item.getCarbs()
            totalFats += item.getFat()
          }
        } else {
          if(item.itemType === 'recipe' && item.category === category) {
            item = new Item(item)
            totalProtein += item.getRecipeProtein()
            totalCarbs += item.getRecipeCarbs()
            totalFats += item.getRecipeFat()
          }
          else if(item.category === category) {
            item = new Item(item)
            totalProtein += item.getProtein()
            totalCarbs += item.getCarbs()
            totalFats += item.getFat()
          }
        }
      })

      totalCalories = (4 * (totalCarbs + totalProtein) + (9 * totalFats)).toFixed(0)
    }

    return (
      <div className="category-macros">
        <label>
          {category.charAt(0).toUpperCase() + category.slice(1)}
        </label>
        <div className="macros">
          <div className="tracker-macros-container">
            <p>{totalProtein.toFixed(1)} P</p>
            <p>{totalCarbs.toFixed(1)} C</p>
            <p>{totalFats.toFixed(1)} F</p>
            <p>{totalCalories} Cal</p>
          </div>
        </div>
      </div>
    )
  }

  const openItem = (data) => {
    if(data.itemType === 'recipe') {
      setShowRecipeModal(true);
      setItem(data)
    }
  }

  return (
    <div style={{padding: '0px 6px 200px 6px'}}>
      {getTotalMacros('breakfast')}
      <div className="tracker-food-list">
        { // eslint-disable-next-line
          trackerData.timeline[trackerData.selectedTrackerDate].map((item) => {
            if(item.category === 'breakfast')
              return(
                <FoodListItem 
                  onClick={() => openItem(item)}
                  key={item.id}
                  item={item} 
                />
              )
        })}
      </div>

      {getTotalMacros('lunch')}
      <div className="tracker-food-list">
        {/* 
          es-lint will throw errors because map should always return a value.
          Adding a .filter() for item categories changes the array indicies, which affects
          the deleteItem function. - Rich
        */}
        { // eslint-disable-next-line
          trackerData.timeline[trackerData.selectedTrackerDate].map((item) => {
            if(item.category === 'lunch')
              return(
                <FoodListItem 
                  onClick={() => openItem(item)}
                  key={item.id}
                  item={item} 
                />
              )
        })}
      </div>

      {getTotalMacros('dinner')}
      <div className="tracker-food-list">
        { // eslint-disable-next-line
          trackerData.timeline[trackerData.selectedTrackerDate].map((item) => {
            if(item.category === 'dinner')
              return(
                <FoodListItem 
                  onClick={() => openItem(item)}
                  key={item.id}
                  item={item} 
                />
              )
        })}
      </div>

      {getTotalMacros('snacks')}
      <div className="tracker-food-list">
        { // eslint-disable-next-line
          trackerData.timeline[trackerData.selectedTrackerDate].map((item) => {
            if(item.category === 'snacks')
              return(
                <FoodListItem 
                  onClick={() => openItem(item)}
                  key={item.id}
                  item={item} 
                />
              )
        })}
      </div>

      {getTotalMacros('other')}
      <div className="tracker-food-list">
        { // eslint-disable-next-line
          trackerData.timeline[trackerData.selectedTrackerDate].map((item) => {
            if(item.category === 'other')
              return(
                <FoodListItem 
                  onClick={() => openItem(item)}
                  key={item.id}
                  item={item} 
                />
              )
        })}
      </div>

      <Modal
        // title={`Remove Account`}
        // message={`Removing this account will immediately deactivate it. The user can still log in, but must enter a payment method and choose a subscription to continue using the Avatar Nutrition service.`}
        // submitLabel="Remove"
        open={showRecipeModal}
        onClose={() => setShowRecipeModal(false)}
        handleSubmit={() => console.log('submit')}
        hideAction
      >
        {item &&
          <RecipeCard
            item={item}
          />
        }
      </Modal>
    </div>
  )
}

export default FoodList
